import React from 'react'

const CompressorLogs = () => {
  return (
    <div>
      
    </div>
  )
}

export default CompressorLogs
